(function() {
    angular
        .module("feedbackModule")
        .controller("FeedbackController", FeedbackController)

    FeedbackController.$inject = [
        "$rootScope",
        "$scope",
        "$filter",
        "feedbackService",
        "DTOptionsBuilder",
        "DTColumnBuilder"
    ]

    function FeedbackController(
        $rootScope,
        $scope,
        $filter,
        feedbackService,
        DTOptionsBuilder,
        DTColumnBuilder
    ){
        "use strict"

        /**
            Variables
         **/
        var dtColumns = []

        /**
            $rootScope variables
         **/
        $rootScope.title = "Customer Feedback | WANCO"

        /**
            Feedback dataTable config
         **/
        $scope.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
                return feedbackService.getFeedback().then(function(data) {
                    return data
                })
            })
            .withPaginationType("simple")
            .withOption("bFilter", false)
            .withOption("bAutoWidth", true)
            .withLanguage({
                "sEmptyTable":     "No data available in table",
                "sInfo":           "Showing _START_ to _END_ of _TOTAL_",
                "sInfoEmpty":      "Showing 0 to 0 of 0",
                "sLengthMenu":     "View _MENU_",
                "sLoadingRecords": "Loading...",
                "sZeroRecords":    "No matching records found",
                "oPaginate": {
                    "sNext":     '<button class="btn btn-default pull-right"><i class="fa fa-angle-right"></i></button>',
                    "sPrevious": '<button class="btn btn-default"><i class="fa fa-angle-left"></i></button>'
                },
                "oAria": {
                    "sSortAscending":  ": activate to sort column ascending",
                    "sSortDescending": ": activate to sort column descending"
                }
            })
            .withOption("sDom", '<"top">rt<"clearfix"><"pull-left"l><"text-right"pfi><"clear">')
            .withOption("responsive", true)
            .withOption("order", [4, "desc"])

        dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle("Name")
                .renderWith(function(data, type, full, meta) {
                    return '<a href="/feedback/details/id/' + data.id + '">' + data.name + "</a>"
                }),
            DTColumnBuilder.newColumn("email").withTitle("Email"),
            DTColumnBuilder.newColumn("subject").withTitle("Subject"),
            DTColumnBuilder.newColumn("status").withTitle("Status"),
            DTColumnBuilder.newColumn(null).withTitle("Created")
                .renderWith(function(data, type, full, meta) {
                    return $filter("date")(data.created_at, "yyyy-MM-dd")
                }),
            DTColumnBuilder.newColumn(null).withTitle("Last Updated")
                .renderWith(function(data, type, full, meta) {
                    return $filter("date")(data.updated_at, "yyyy-MM-dd")
                })
        ]

        $scope.dtColumns = dtColumns
    }
})()
